export class Article {
	constructor() {
	}
} 
